import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=3b8255e2&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=ts&"
export * from "./CompaniesList.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=3b8255e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8255e2",
  null
  
)

export default component.exports